import React from 'react'
import { Tag, Button, Space } from 'antd'
import {
  STATUS_COLORS,
  PAYMENT_MODE_COLORS,
  PAYMENT_MODE_LABELS,
  GATEWAY_COLORS,
  GATEWAY_LABELS,
  claimedName,
  formatMoney
} from './utils'
import { serviceTag } from '../DutyAssistant/statusColors'

// Columns for the duty-payment transactions table. "View chat" links to the originating
// conversation; "Timeline" pulls the on-demand payment-attempt timeline for unpaid transactions.
/* eslint-disable react/display-name */
export const columns = (onViewConversation, onViewTimeline, onRefund) => [
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    render: ref => <span style={{ fontFamily: 'monospace' }}>{ref}</span>
  },
  {
    // Which service the money was for. The list was duty-only until 2026-10-30; with vehicle
    // history and tracking payments on it too, "Car — —" on a report order would read as a bug.
    title: 'Service',
    dataIndex: 'service',
    key: 'service',
    render: value => serviceTag(value)
  },
  {
    title: 'Car',
    dataIndex: 'carSummary',
    key: 'carSummary',
    render: (text, record) => (
      <div>
        <div>{text || '—'}</div>
        {record.carPosition ? (
          <div style={{ fontSize: 12, color: '#888' }}>
            Car #{record.carPosition}
          </div>
        ) : null}
      </div>
    )
  },
  {
    title: 'WhatsApp',
    dataIndex: 'waIdMasked',
    key: 'waIdMasked',
    render: v => v || '—'
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'right',
    render: (amount, record) => (
      <div>
        <div>{formatMoney(amount, record.currency)}</div>
        {record.paymentMode === 'merchant' && claimedName(record.note) ? (
          <div style={{ fontSize: 12, color: '#888' }}>
            {claimedName(record.note)}
          </div>
        ) : null}
      </div>
    )
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <Tag color={STATUS_COLORS[status] || 'default'}>{status}</Tag>
    )
  },
  {
    title: 'Method',
    dataIndex: 'method',
    key: 'method',
    render: v => v || '—'
  },
  {
    // Which company moved the money, and on which way of paying (spec: payment-gateway-routing
    // Req 4.1). `Method` above is the older, looser field and stays for rows that predate the
    // axis; these two are what anything now decides on.
    title: 'Gateway',
    dataIndex: 'gateway',
    key: 'gateway',
    render: (gateway, record) =>
      gateway ? (
        <Space direction="vertical" size={0}>
          <Tag color={GATEWAY_COLORS[gateway] || 'default'}>
            {GATEWAY_LABELS[gateway] || gateway}
          </Tag>
          {record.rail ? <span style={{ fontSize: 12, color: '#888' }}>{record.rail}</span> : null}
        </Space>
      ) : (
        // Blank on a row from before the axis, or one whose charge never started.
        <span style={{ color: '#aaa' }}>—</span>
      )
  },
  {
    title: 'Mode',
    dataIndex: 'paymentMode',
    key: 'paymentMode',
    render: mode =>
      mode ? (
        <Tag color={PAYMENT_MODE_COLORS[mode] || 'default'}>
          {PAYMENT_MODE_LABELS[mode] || mode}
        </Tag>
      ) : (
        <span style={{ color: '#aaa' }}>—</span>
      )
  },
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: v => (v ? new Date(v).toLocaleString() : '—')
  },
  {
    title: 'Action',
    key: 'action',
    fixed: 'right',
    width: 200,
    render: (_, record) => (
      <Space>
        {record.conversationId ? (
          <Button size="small" onClick={() => onViewConversation(record)}>
            View chat
          </Button>
        ) : null}
        {record.status !== 'SUCCESSFUL' ? (
          <Button size="small" onClick={() => onViewTimeline(record)}>
            Timeline
          </Button>
        ) : null}
        {/* Only a settled payment can be refunded, and whether a GATEWAY can send it is the
            server's answer — the modal asks before it offers the button (companion Req 3.1). */}
        {record.status === 'SUCCESSFUL' && onRefund ? (
          <Button size="small" onClick={() => onRefund(record)}>
            {(record.refunds || []).length ? 'Refunds' : 'Refund'}
          </Button>
        ) : null}
      </Space>
    )
  }
]
/* eslint-enable react/display-name */
